import { IconProps } from "../../../types/style";

const BoxSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20.21 7.81999L12.51 12.28C12.2 12.46 11.81 12.46 11.49 12.28L3.78997 7.81999C3.23997 7.49999 3.09997 6.74999 3.51997 6.27999C3.80997 5.94999 4.13997 5.67999 4.48997 5.48999L9.90997 2.48999C11.07 1.83999 12.95 1.83999 14.11 2.48999L19.53 5.48999C19.88 5.67999 20.21 5.95999 20.5 6.27999C20.9 6.74999 20.76 7.49999 20.21 7.81999Z'
          fill={color}
        />
        <path
          d='M11.43 14.14V20.96C11.43 21.72 10.66 22.22 9.97998 21.89C7.91998 20.88 4.44998 18.99 4.44998 18.99C3.22998 18.3 2.22998 16.56 2.22998 15.13V9.96999C2.22998 9.17999 3.05998 8.67999 3.73998 9.06999L10.93 13.24C11.23 13.43 11.43 13.77 11.43 14.14Z'
          fill={color}
        />
        <path
          d='M12.5701 14.14V20.96C12.5701 21.72 13.3401 22.22 14.0201 21.89C16.0801 20.88 19.5501 18.99 19.5501 18.99C20.7701 18.3 21.7701 16.56 21.7701 15.13V9.96999C21.7701 9.17999 20.9401 8.67999 20.2601 9.06999L13.0701 13.24C12.7701 13.43 12.5701 13.77 12.5701 14.14Z'
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BoxSVG;
